<template>
    <router-view />
</template>

<script>
    //Fake view need for nested routes
    export default {
        name: 'LangPart',
    }
</script>


// WEBPACK FOOTER //
// src/components/views/LangPart.vue